import { N40, N600, N700 } from '@atlaskit/theme/colors';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import styled from '@emotion/styled';
import React from 'react';
import { LayoutDeveloperModeType } from '../../../../../model/side-information-component';

export function LayoutDeveloperMode({
  showListContent,
  productListMsg,
  isSideInfoHeader,
  sideInfoHeaderMsg,
  isMobile,
  isEdition,
  edition
}: LayoutDeveloperModeType) {
  return (
    <DeveloperModeLayout>
      {isSideInfoHeader && (
        <ProductHeading>
          <SanitizedFormattedHtmlMessage {...sideInfoHeaderMsg} />
        </ProductHeading>
      )}

      {!isMobile && (
        <LogoAndEdition>
          {isEdition && <Edition>{edition}</Edition>}
        </LogoAndEdition>
      )}

      {showListContent && (
        <FeaturesDiv>
          <SanitizedFormattedHtmlMessage {...productListMsg} />
        </FeaturesDiv>
      )}
    </DeveloperModeLayout>
  );
}

const DeveloperModeLayout = styled.div`
  font-family: Charlie Display, -apple-system, BlinkMacSystemFont, Segoe UI,
    Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: ${N600};
`;

const ProductHeading = styled.div`
  font-size: 40px;
  font-weight: 500;
  max-width: 360px;
  line-height: 42px;
`;

const LogoAndEdition = styled.div`
  position: relative;
  margin-bottom: 24px;
  padding-bottom: 4px;
  border-bottom: 1px solid ${N40};
`;

const Edition = styled.div`
  font-weight: 500;
  font-family: Charlie Display, -apple-system, BlinkMacSystemFont, Segoe UI,
    Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
  font-style: normal;
  letter-spacing: 0.3px;
  margin-top: 20px;
  color: ${N700};
  font-size: 1.5rem;
  line-height: 1.33333333;
`;

const FeaturesDiv = styled.div`
  ul {
    list-style-type: none;
    padding: 6px 0 10px 20px;

    li {
      position: relative;
      font-size: 22px;
      font-weight: 500;
      margin-bottom: 11px;

      &::before {
        background-image: url("data:image/svg+xml,%3Csvg width='13px' height='13px' viewBox='0 0 13 13' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round'%3E%3Cg transform='translate(0.000000, -51.000000)' stroke='%2336B37E' stroke-width='1.6'%3E%3Cg transform='translate(1.000000, 45.000000)'%3E%3Cg transform='translate(0.000000, 0.416810)'%3E%3Cpolyline points='1.52655666e-16 11.9766645 3.98219585 17 11 7'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        content: '';
        display: inline-block;
        position: absolute;
        left: -20px;
        top: 11px;
        height: 13px;
        width: 13px;
      }
    }
  }
`;
